import requests from "./httpService";

const ReportServices = {
  getDashboardTotals(storeId, startDate, endDate) {
    // Format dates to ISO string format for consistency
    const formattedStartDate =
      startDate instanceof Date ? startDate.toISOString() : startDate;
    const formattedEndDate =
      endDate instanceof Date ? endDate.toISOString() : endDate;

    return requests.get(`/api/reports/${storeId}/dashboard-totals`, {
      params: { startDate: formattedStartDate, endDate: formattedEndDate },
    });
  },

  getTopEmployees(storeId, startDate, endDate) {
    const formattedStartDate =
      startDate instanceof Date ? startDate.toISOString() : startDate;
    const formattedEndDate =
      endDate instanceof Date ? endDate.toISOString() : endDate;
    return requests.get(`/api/reports/${storeId}/top-employees`, {
      params: { startDate: formattedStartDate, endDate: formattedEndDate },
    });
  },

  getTopServices(storeId, startDate, endDate) {
    const formattedStartDate =
      startDate instanceof Date ? startDate.toISOString() : startDate;
    const formattedEndDate =
      endDate instanceof Date ? endDate.toISOString() : endDate;
    return requests.get(`/api/reports/${storeId}/top-services`, {
      params: { startDate: formattedStartDate, endDate: formattedEndDate },
    });
  },

  getPaymentMethodTotals(storeId, startDate, endDate) {
    const formattedStartDate =
      startDate instanceof Date ? startDate.toISOString() : startDate;
    const formattedEndDate =
      endDate instanceof Date ? endDate.toISOString() : endDate;
    return requests.get(`/api/reports/${storeId}/payment-method-totals`, {
      params: { startDate: formattedStartDate, endDate: formattedEndDate },
    });
  },
};

export default ReportServices;
